import { IconCloudUpload, IconLoader2 } from '@tabler/icons-react'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useEmployeeAPI } from 'src/API/rest.employee'
import { useReadTotalForcasts } from 'src/API/rest.forecast'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { MonthCode } from 'src/API/rest.forecast_regionwise'
import { useOnlineForcast } from 'src/API/rest.OnlineForecast'
import { useStatesAPI } from 'src/API/rest.states'
import { ButtonIconSquare } from 'src/components/buttons'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { FileInputDragDropStandard } from 'src/components/standard.fileDroper'
import { InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { StandardTable, StandardTableHeader, StandardTableRow } from 'src/components/standard.table'
import { TypographyH2 } from 'src/components/typography'
import { toast } from 'src/shadcn/ui/use-toast'
import { ModalValidationError } from './component.validationErrorModal'



export function OnlineForecastPage() {
    const [seletedFile, setSelectedFile] = useState<File | null>(null)
    const [validationErrors, setValidationErrors] = useState<any | null>(
        null
    )
    const [isOpen, setIsOpen] = useState(false)

    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,

        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })


    const {
        downloadTemplateOnlineforecast,
        isDownloadingTEmplateOnlineforecast,
        isDownloadOnlineforcastTemplateError,
        validateOnlineforecastExel,
        isvalidateingOnlineforecastExel,
        uploadOnlineforecastExel,
        uploadProgress,
        isuploadingOnlineforecastExel
    } = useOnlineForcast({})

    const {
        states,
        isError: isStateError,
        isFetching: isFetchingState,
        isLoading: isLoadingState
    } = useStatesAPI({
        trigger: true,
        isState: 0
    })

    const {
        readtotalRegionForecast,
        isReadtotalRegionForecast,
        readtotalNPDForecast,
        isReadtotalNPDForecast
    } = useReadTotalForcasts()
    const [employeesRow, setEmployeesRow] = useState<StandardTableRow[]>([
        {
            id: 'head',
            datas: {
                head: { id: 'head', data: 'Total' },
                M1: { id: 'M1', data: '' },
                M2: { id: 'M2', data: '' },
                M3: { id: 'M3', data: '' },
            }
        },
        {
            id: 'head',
            datas: {
                head: { id: 'head', data: 'NPD' },
                M1: { id: 'M1', data: '' },
                M2: { id: 'M2', data: '' },
                M3: { id: 'M3', data: '' },
            }
        },
    ])
    const headers: StandardTableHeader[] = [
        { label: 'Head', id: 'head', whiteSpace: 'nowrap' },
        { label: 'M1', id: 'M1', whiteSpace: 'nowrap' },
        { label: 'M2', id: 'M2', whiteSpace: 'nowrap' },
        { label: 'M3', id: 'M3', whiteSpace: 'nowrap' },
    ]


    const isAnyError = isErrorlatestCalendarDate
    const isAnyFething = isFetchinglatestCalendarDate
    const isLoading = isLoadinglatestCalendarDate

    useEffect(
        () => {

            if (states?.length) {
                const online = states.find((state) => state.FM04_StateName === 'Online')
                if (online) {
                    readtotalRegionForecast({
                        stateId: online.FM04_StateID,
                        channel: 'Distributor',
                        date: latestCalendarDate?.date || ''
                    }).then(
                        (res) => {

                            if (res.success) {
                                const data = res.data
                                const M1 = data.M1 || 0
                                const M2 = data.M2 || 0
                                const M3 = data.M3 || 0
                                readtotalNPDForecast({
                                    stateId: online.FM04_StateID,
                                    channel: 'Distributor',
                                    date: latestCalendarDate?.date!
                                }).then(
                                    (res2) => {
                                        if (res.success) {
                                            const data = res2.data
                                            const MNPB1 = data.M1 || 0
                                            const MNPB2 = data.M2 || 0
                                            const MNPB3 = data.M3 || 0
                                            setEmployeesRow([
                                                {
                                                    id: 'head',
                                                    datas: {
                                                        head: { id: 'head', data: 'Total' },
                                                        M1: { id: 'M1', data: Math.round(M1 / 100000) },
                                                        M2: { id: 'M2', data: Math.round(M2 / 100000) },
                                                        M3: { id: 'M3', data: Math.round(M3 / 100000) },
                                                    }
                                                },
                                                {
                                                    id: 'head',
                                                    datas: {
                                                        head: { id: 'head', data: 'NPD' },
                                                        M1: { id: 'M1', data: Math.round(MNPB1 / 100000) },
                                                        M2: { id: 'M2', data: Math.round(MNPB2 / 100000) },
                                                        M3: { id: 'M3', data: Math.round(MNPB3 / 100000) },
                                                    }
                                                },
                                            ])
                                        }
                                    }
                                )

                            }

                        }
                    )
                }

            }

        }, [isFetchingState]
    )


    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col overflow-auto items-center '>


            {/* NP style wise */}
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-2 '>
                    <TypographyH2>Online Forecast</TypographyH2>
                    <div className=' flex gap-2 '>
                        {/* <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='date'
                            disabled
                            value={latestCalendarDate?.date || ''}
                        /> */}
                        <InputStandard
                            title='Date'
                            placeholder='Date'
                            disabled
                            value={latestCalendarDate?.date ? format(latestCalendarDate?.date, 'MMMM yyyy') : ''}
                        />
                        <ModalValidationError
                            invalidData={validationErrors || null}
                            show={isOpen}
                            setShow={setIsOpen}
                        />
                    </div>
                    <div className=' py-2 flex justify-center'>
                        <div className=' border'>
                            <StandardTable
                                headers={headers}
                                rows={employeesRow}
                                isLoading={isReadtotalRegionForecast || isReadtotalNPDForecast}
                                rowsPerPrevousePage={2}
                                isUpdating={false}
                            />
                        </div>
                    </div>
                    <div className=' grow flex flex-col justify-center items-center  w-min mx-auto mt-8'>
                        <div className='  text-center flex text-vstargray-800 dark:text-vstargray-100 py-2'>Download Template {isDownloadingTEmplateOnlineforecast ? <IconLoader2 size={10} className=' inline animate-spin' /> : <span onClick={() => downloadTemplateOnlineforecast({
                            date: latestCalendarDate?.date!
                        })} className=' underline text-blue-500 cursor-pointer hover:text-blue-700'>here</span>}</div>
                        <FileInputDragDropStandard
                            disabled={!latestCalendarDate?.date ? true : false}
                            onDrop={async (file) => {
                                const response = await validateOnlineforecastExel({
                                    file: file!
                                })
                                if (response.success === false) {
                                    toast({
                                        description: response.message
                                    })
                                    setValidationErrors((response as any).errors || null)
                                    if ((response as any).errors)
                                        setIsOpen(true)
                                } else {
                                    setSelectedFile(file);
                                }
                            }}
                            file={seletedFile}
                            onClear={() => setSelectedFile(null)}
                            accept={{ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }}
                        />
                    </div>
                    <ButtonIconSquare
                        disabled={seletedFile === null}
                        className=' mx-auto mb-5'
                        icon={isuploadingOnlineforecastExel ? <IconLoader2 className='animate-spin' /> : <IconCloudUpload />}
                        onClick={async () => {
                            const response = await uploadOnlineforecastExel({
                                date: latestCalendarDate?.date!,
                                file: seletedFile!,
                            })
                            if (response.success === false) {
                                toast({
                                    title: 'Error',
                                    description: response.message
                                })
                            } else {
                                toast({
                                    title: 'Success',
                                    description: response.message
                                })
                                setSelectedFile(null)
                            }
                        }}
                        variant='secondary'
                        text='Submit' />
                </div>
            </div>

        </div>
    )
}

